import { useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [
  ["name", "Nombre completo *"], ["dni", "DNI / NIE / Pasaporte"], ["phone", "Teléfono"],
  ["email", "Email"], ["address", "Dirección"],
];

export const ContactForm = ({ property, who, onChanged, canWrite }) => {
  const saved = property[who] || {};
  const [form, setForm] = useState({ name: "", dni: "", phone: "", email: "", address: "", notes: "", ...saved });
  const [saving, setSaving] = useState(false);
  const dirty = JSON.stringify(form) !== JSON.stringify({ name: "", dni: "", phone: "", email: "", address: "", notes: "", ...saved });

  const save = async () => {
    if (!form.name.trim()) return toast.error("El nombre es obligatorio");
    setSaving(true);
    try {
      await api.put(`/properties/${property.id}`, { [who]: form });
      toast.success(who === "seller" ? "Datos del vendedor guardados" : "Datos del comprador guardados");
      onChanged();
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };

  if (!canWrite) {
    return (
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
        {FIELDS.map(([k, l]) => <div key={k}><dt className="text-muted-foreground">{l.replace(" *", "")}</dt><dd>{saved[k] || "—"}</dd></div>)}
      </dl>
    );
  }
  return (
    <div className="space-y-2" data-testid={`contact-form-${who}`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {FIELDS.map(([k, l]) => (
          <Input key={k} data-testid={`contact-${who}-${k}`} value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={l} className="h-8 text-xs" />
        ))}
      </div>
      <Textarea value={form.notes || ""} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Notas (situación, plazos, hipoteca…)" rows={2} className="text-xs" />
      {dirty && <Button size="sm" className="h-7 text-xs" onClick={save} disabled={saving} data-testid={`contact-save-${who}`}><Save size={12} className="mr-1" /> {saving ? "Guardando…" : "Guardar datos"}</Button>}
    </div>
  );
};
